import {
    AtualizarClassificacaoCobrancaService,
    CadastrarClassificacaoCobrancaService,
    DeletarClassificacaoCobrancaService,
    GetClassificacaoCobrancaService,
    ListarClassificacaoCobrancaGrupoExcecaoService,
    ListarClassificacaoCobrancaService,
    RemoverClassificacaoManualService,
} from "../../../Services/Cobranca/ClassificacaoCobranca/ClassificacaoCobrancaService";

import { ClassificacaoCobrancaInterface } from "../../../Interfaces/Cobranca/ClassificacaoCobranca/ClassificacaoCobrancaInterface";
import { Controller } from "../../Controller";

export async function AtualizarClassificacaoCobrancaController(
    requestBody: ClassificacaoCobrancaInterface
) {
    return Controller(AtualizarClassificacaoCobrancaService(requestBody));
}

export async function ListarClassificacaoCobrancaController() {
    return Controller(ListarClassificacaoCobrancaService());
}

export async function CadastrarClassificacaoCobrancaController(
    requestBody: ClassificacaoCobrancaInterface
) {
    return Controller(CadastrarClassificacaoCobrancaService(requestBody));
}

export async function DeletarClassificacaoCobrancaController(
    idClassificacaoCobranca: number
) {
    return Controller(
        DeletarClassificacaoCobrancaService(idClassificacaoCobranca)
    );
}

export async function ListarClassificacaoCobrancaGrupoExcecaoController() {
    return Controller(ListarClassificacaoCobrancaGrupoExcecaoService());
}

export async function GetClassificacaoCobrancaController(
    ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA: number
) {
    return Controller(
        GetClassificacaoCobrancaService(ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA)
    );
}

export async function RemoverClassificacaoManualController(
    ID_CHAVE_ERP: string
) {
    return Controller(RemoverClassificacaoManualService(ID_CHAVE_ERP));
}
